import sessionStore from 'client/Session/SessionStore';

import {useIsFeatureFlagEnabled} from './featureFlag.utils';

/**
 * The single app-wide launch gate for the teacher dashboard: flag on, resolved, and the actor is a
 * teacher. `hasTeacherDashboard` stays false while the flag loads so callers render legacy without
 * a flash. Non-teachers skip the query so an anonymous `false` never gets cached for the session.
 */
export const useHasTeacherDashboard = ({skip = false}: {skip?: boolean} = {}) => {
  const isTeacher = sessionStore.isTeacher();
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('teacher_dashboard_v2', {
    skip: skip || !isTeacher
  });

  return {
    hasTeacherDashboard: isFeatureEnabled && !isLoading && isTeacher,
    isLoading
  };
};
